module.exports = __webpack_public_path__ + "static/media/header_bg.aec37603.png";